import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { CloseButtonProps } from './types';

const CloseButton: React.FunctionComponent<CloseButtonProps> = (props) => {
  const { onClick, ...buttonProps } = props;
  const renderCloseButton = () => {
    return (
      <IconButton size='small' onClick={onClick} {...buttonProps}>
        <Close />
      </IconButton>
    );
  };

  return renderCloseButton();
};

export default CloseButton;
